import React, { Dispatch, FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import ServiceSectionAccordionContent from '../accordionContent/ServiceSectionAccordionContent';
import GenericAccordion from '../../../../../../common/components/presentation/genericAccordion/GenericAccordion';
import IServicePlan from '../../../../../model/IServicePlan';
import SectionStatesWrapper, {
  ISectionStatesProps,
} from '../../../../../../common/components/configuratorStates/SectionStatesWrapper';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../react/navigation/useScrollToSection';
import Translation from '../../../../../../common/components/translation/Translation';
import servicePlansSectionStyles from './ServicePlansSectionStyles';

export interface IServicePlanSectionProps extends ISectionStatesProps {
  servicePlans?: Record<string, IServicePlan>;
  expanded: boolean;
  setExpanded: Dispatch<boolean>;
  onClick: (servicePlanId: string) => void;
  selectedServicePlan: string;
}

const ServicePlansSection: FunctionComponent<IServicePlanSectionProps> = ({
  expanded,
  setExpanded,
  servicePlans,
  onClick,
  selectedServicePlan,
  error,
  loading,
}) => {
  const { scrollToDisclaimer } = useScrollToSection();
  const styles = servicePlansSectionStyles();

  return (
    <GenericAccordion
      expanded={expanded}
      setExpanded={setExpanded}
      summary={
        <>
          <Typography variant="sectionTitle">
            <Translation id="spc.customise.serviceSection.title" />
            <IndicativeNumber
              dataTest="servicePlan"
              displayNumber={<Translation id="spc.customise.indicative.servicePlan" />}
              onClick={scrollToDisclaimer}
              className={styles.indicativeNumber}
            />
          </Typography>
        </>
      }
      details={
        <SectionStatesWrapper loading={loading} error={error}>
          <ServiceSectionAccordionContent
            selectedServicePlan={selectedServicePlan}
            servicePlanListItems={servicePlans}
            onClick={onClick}
          />
        </SectionStatesWrapper>
      }
    />
  );
};

export default ServicePlansSection;
